import { render } from "./NewIssue.vue?vue&type=template&id=19fa7ddc&scoped=true"
import script from "./NewIssue.vue?vue&type=script&lang=js"
export * from "./NewIssue.vue?vue&type=script&lang=js"

import "./NewIssue.vue?vue&type=style&index=0&id=19fa7ddc&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fa7ddc"]])

export default __exports__